import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<div class="slex-divider slex-divider--labeled" role="separator"><span class="slex-divider-label"><!> <!></span></div>`);
var root_2 = $.from_html(`<hr class="slex-divider"/>`);

export default function Divider($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var div = root_1();
			var span = $.child(div);
			var node_1 = $.child(span);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-divider-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span_1 = root();
					var text_1 = $.child(span_1, true);

					$.reset(span_1);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label)]);
					$.append($$anchor, span_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).label) $$render(consequent_1);
				});
			}

			$.reset(span);
			$.reset(div);
			$.append($$anchor, div);
		};

		var alternate = ($$anchor) => {
			var hr = root_2();

			$.append($$anchor, hr);
		};

		$.if(node, ($$render) => {
			if ($.get(p).label || $.get(p).icon) $$render(consequent_2); else $$render(alternate, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}